import { usePermissions } from 'permissions';
import { Card, Col, Row, withErrorBoundary } from 'ui';
import { CreateContentObjectTrigger } from '../create-content-object-trigger';
import { MainFeed } from '../main-feed';
import { PinnedFeed } from '../pinned-feed';

const HomeFeed = () => {
  const { canCreateContentObject } = usePermissions();

  return (
    <Row gutter={[0, 'ms']}>
      {canCreateContentObject({}) ? (
        <Col span={24}>
          <Card marginBottom={false}>
            <CreateContentObjectTrigger />
          </Card>
        </Col>
      ) : null}
      <Col span={24}>
        <PinnedFeed />
      </Col>
      <Col span={24}>
        <MainFeed />
      </Col>
    </Row>
  );
};

export default withErrorBoundary(HomeFeed);
